export class UserDto {
  id: string;
  email: string;
  applicationAccesses: Array<string>;
}
